<template>
  <th
    class="px-4 py-4 "
    style="color : trasnperent"
    :style="[{ width: width, maxWidth: width, left: left }]"
  >
    <slot></slot>
  </th>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "auto"
    },
    left: {
      type: String,
      default: "auto"
    }
  }
};
</script>
